<template>
  <div id="agESRIConn">
    <b-input-group size="md" prepend="Auth URL">
      <b-input type="text" v-model="connection.authUrl" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
  </div>
</template>


<script>
// components

// server

// modules

export default {
  name: "ag-esri-conn",

  props: {
    isReadonly: Boolean,
    connection: Object,
  },

  data() {
    return {
    };
  },

  computed: {

  },

  methods: {

    // UI Events

    // other

    reset() {
      
    },

    prepareForSave() {
      
    },

  }
};
</script>


<style scoped lange="css">

</style>


// WEBPACK FOOTER //
// src/components/connection/ESRIConnection.vue